export default __webpack_public_path__ + "static/media/template7.26fc5085.svg";